import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_acl = _resolveDirective("acl");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createVNode($setup["Grid"], {
                "current-page": $setup.currentPage,
                "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event) => (($setup.currentPage) = $event)),
                "paginated-results": "",
                access: $props.access,
                columns: $setup.gridColumns,
                data: $setup.gridData,
                "is-loading": $setup.allHospitalChangeRequestLoading,
                "page-info": $setup.cursors[$setup.currentPage - 1],
                "page-size": $setup.pageSize,
                "total-pages": $setup.cursors.length,
                onView: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('view', $event)))
            }, null, 8, ["current-page", "access", "columns", "data", "is-loading", "page-info", "page-size", "total-pages"]), [
                [_directive_acl, $props.access, "root"]
            ])
        ])
    ]));
}
